import moment from "moment";
import * as types from "./types";
import database from "../config/database";

const current_month = moment();
const second_month = moment().add(1, "months");
const third_month = moment().add(2, "months");

export function actionFetchTimeslotsSoonestTriggered(payload) {
  return {
    type: types.FETCH_TIMESLOTS_SOONEST_TRIGGER,
    value: payload
  };
}

export function functionFetchTimeslotsSoonestTriggered(
  triggeredSoonest,
  triggeredSoonestTime
) {
  return dispatch => {
    dispatch(
      actionFetchTimeslotsSoonestTriggered({
        triggeredSoonest,
        triggeredSoonestTime
      })
    );
  };
}

export function actionFetchTimeslotsSoonestAdvanced(payload) {
  return {
    type: types.FETCH_TIMESLOTS_SOONEST_ADVANCED,
    value: payload
  };
}

export function functionFetchTimeslotsSoonestAdvanced(
  startingTime,
  endingTime
) {
  return dispatch => {
    database
      .ref("/app/timeslots")
      .orderByChild("durationTimestamp/start")
      .startAt(startingTime)
      .endAt(endingTime)
      .once("value", snapshot => {
        const timeslots = snapshot.val();
        dispatch(
          actionFetchTimeslotsSoonestAdvanced({
            ...timeslots
          })
        );
      });
  };
}

export function actionFetchTimeslotsSoonest(payload) {
  return {
    type: types.FETCH_TIMESLOTS_SOONEST,
    value: payload
  };
}

export function functionFetchTimeslotsSoonest(startingTime) {
  return dispatch => {
    database
      .ref("/app/timeslots")
      .orderByChild("durationTimestamp/start")
      .startAt(startingTime)
      .limitToFirst(1)
      .once("value", snapshot => {
        const timeslots = snapshot.val();

        dispatch(
          actionFetchTimeslotsSoonest({
            ...timeslots
          })
        );
      });
  };
}

export function actionFetchTimeslots(payload) {
  return {
    type: types.FETCH_TIMESLOTS,
    value: payload
  };
}

export function functionFetchTimeslots(startingTime, endingTime) {
  return dispatch => {
    database
      .ref("/app/timeslots")
      .orderByChild("durationTimestamp/start")
      .startAt(startingTime)
      .endAt(endingTime)
      .once("value", snapshot => {
        const timeslots = snapshot.val();

        dispatch(
          actionFetchTimeslots({
            ...timeslots
          })
        );
      });
  };
}

export function actionFetchTimeslotsBoolean(payload) {
  return {
    type: types.FETCH_TIMESLOTS_BOOLEAN,
    value: payload
  };
}

export function functionFetchTimeslotsBoolean() {
  return dispatch => {
    // MAIN ARRAY
    const itHasTimeslots = [];

    // let daysLeftToNextMonth = current_month.diff(endOfMonth, 'days');
    // let total_days_of_month = parseInt(Math.abs(daysLeftToNextMonth));
    // let month1stLoop = moment().add(total_days_of_month, 'days');

    // CURRENT MONTH
    const endOfMonth = moment(current_month).endOf("month");

    for (
      let m = moment(current_month);
      m.isBefore(endOfMonth);
      m.add(1, "days")
    ) {
      const startT = moment(m)
        .startOf("day")
        .valueOf();
      const endT = moment(m)
        .startOf("day")
        .clone()
        .set({ hour: 23, minute: 0, second: 0 })
        .valueOf();

      const setSelectedDate_startTime = moment(m)
        .set({ hour: 5, minute: 0, second: 0 })
        .valueOf();
      const setSelectedDate_endTime = moment(m)
        .set({ hour: 23, minute: 0, second: 0 })
        .valueOf();

      const ifStartOfMonth = moment(m)
        .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
        .valueOf();
      const theStartOfMonth = moment(current_month)
        .startOf("month")
        .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
        .valueOf();

      if (ifStartOfMonth === theStartOfMonth) {
        const monthName = endOfMonth.format("MMMM");

        database
          .ref("/app/timeslots")
          .orderByChild("durationTimestamp/start")
          .startAt(startT)
          .endAt(endT)
          .once("value", snapshot => {
            const isActive = snapshot.val() ? "yes" : "no";
            itHasTimeslots.push({
              active: isActive,
              s: setSelectedDate_startTime,
              e: setSelectedDate_endTime,
              monthName
            });
          });
      } else {
        const monthName = false;

        database
          .ref("/app/timeslots")
          .orderByChild("durationTimestamp/start")
          .startAt(startT)
          .endAt(endT)
          .once("value", snapshot => {
            const isActive = snapshot.val() ? "yes" : "no";
            itHasTimeslots.push({
              active: isActive,
              s: setSelectedDate_startTime,
              e: setSelectedDate_endTime,
              monthName
            });
          });
      }
    }

    // SECOND MONTH
    const endOfMonth_second = moment(second_month).endOf("month");

    for (
      let m2nd = moment(second_month).startOf("month");
      m2nd.isBefore(endOfMonth_second);
      m2nd.add(1, "days")
    ) {
      const startT = moment(m2nd)
        .startOf("day")
        .valueOf();
      const endT = moment(m2nd)
        .startOf("day")
        .clone()
        .set({ hour: 23, minute: 0, second: 0 })
        .valueOf();

      const setSelectedDate_startTime = moment(m2nd)
        .set({ hour: 5, minute: 0, second: 0 })
        .valueOf();
      const setSelectedDate_endTime = moment(m2nd)
        .set({ hour: 23, minute: 0, second: 0 })
        .valueOf();

      const ifStartOfMonth = moment(m2nd)
        .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
        .valueOf();
      const theStartOfMonth = moment(second_month)
        .startOf("month")
        .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
        .valueOf();

      if (ifStartOfMonth === theStartOfMonth) {
        const monthName = endOfMonth_second.format("MMMM");

        database
          .ref("/app/timeslots")
          .orderByChild("durationTimestamp/start")
          .startAt(startT)
          .endAt(endT)
          .once("value", snapshot => {
            const isActive = snapshot.val() ? "yes" : "no";
            itHasTimeslots.push({
              active: isActive,
              s: setSelectedDate_startTime,
              e: setSelectedDate_endTime,
              monthName
            });
          });
      } else {
        const monthName = false;

        database
          .ref("/app/timeslots")
          .orderByChild("durationTimestamp/start")
          .startAt(startT)
          .endAt(endT)
          .once("value", snapshot => {
            const isActive = snapshot.val() ? "yes" : "no";
            itHasTimeslots.push({
              active: isActive,
              s: setSelectedDate_startTime,
              e: setSelectedDate_endTime,
              monthName
            });
          });
      }
    }

    // THIRD MONTH
    const endOfMonth_third = moment(third_month).endOf("month");

    for (
      let m3rd = moment(third_month).startOf("month");
      m3rd.isBefore(endOfMonth_third);
      m3rd.add(1, "days")
    ) {
      const startT = moment(m3rd)
        .startOf("day")
        .valueOf();
      const endT = moment(m3rd)
        .startOf("day")
        .clone()
        .set({ hour: 23, minute: 0, second: 0 })
        .valueOf();

      const setSelectedDate_startTime = moment(m3rd)
        .set({ hour: 5, minute: 0, second: 0 })
        .valueOf();
      const setSelectedDate_endTime = moment(m3rd)
        .set({ hour: 23, minute: 0, second: 0 })
        .valueOf();

      const ifStartOfMonth = moment(m3rd)
        .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
        .valueOf();
      const theStartOfMonth = moment(third_month)
        .startOf("month")
        .set({ hour: 23, minute: 0, second: 0, millisecond: 0 })
        .valueOf();

      if (ifStartOfMonth === theStartOfMonth) {
        const monthName = endOfMonth_third.format("MMMM");

        database
          .ref("/app/timeslots")
          .orderByChild("durationTimestamp/start")
          .startAt(startT)
          .endAt(endT)
          .once("value", snapshot => {
            const isActive = snapshot.val() ? "yes" : "no";
            itHasTimeslots.push({
              active: isActive,
              s: setSelectedDate_startTime,
              e: setSelectedDate_endTime,
              monthName
            });
          });
      } else {
        const monthName = false;

        database
          .ref("/app/timeslots")
          .orderByChild("durationTimestamp/start")
          .startAt(startT)
          .endAt(endT)
          .once("value", snapshot => {
            const isActive = snapshot.val() ? "yes" : "no";
            itHasTimeslots.push({
              active: isActive,
              s: setSelectedDate_startTime,
              e: setSelectedDate_endTime,
              monthName
            });
          });
      }
    }

    dispatch(
      actionFetchTimeslotsBoolean({
        itHasTimeslots
      })
    );
  };
}

export function actionFetchAppointmentTime(payload) {
  return {
    type: types.FETCH_TIME,
    value: payload
  };
}

export function functionFetchAppointmentTime(location, locationz) {
  return dispatch => {
    dispatch(
      actionFetchAppointmentTime({
        location,
        locationz
      })
    );
  };
}

export function actionSetTimeslotLocation(payload) {
  return {
    type: types.SET_TIMESLOT_LOCATION,
    value: payload
  };
}

export function functionSetTimeslotFilter(name) {
  return dispatch => {
    dispatch(
      actionSetTimeslotLocation({
        name
      })
    );
  };
}

export function actionSetTimeslotLocationName(payload) {
  return {
    type: types.SET_TIMESLOT_LOCATION_NAME,
    value: payload
  };
}

export function functionSetTimeslotFilterName(name, id) {
  return dispatch => {
    dispatch(
      actionSetTimeslotLocationName({
        name,
        id
      })
    );
  };
}

export function actionFilteredTS(payload) {
  return {
    type: types.FILTERED_TIMESLOTS,
    value: payload
  };
}

export function functionFilteredTS(filteredTimeslots) {
  return dispatch => {
    dispatch(
      actionFilteredTS({
        filteredTimeslots
      })
    );
  };
}
